<template>
  <div>
    <v-btn
      v-if="expenses_loading == true"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="expenses_loading"
    ></v-btn>
    <v-simple-table v-if="grid">
      <thead>
        <tr>
          <th class="primary--text">
            <span v-if="expenseType == 'Insurance'">{{
              $i18n.t("Insurance No.")
            }}</span>
            <span v-if="expenseType == 'Permits'">{{
              $i18n.t("Permit Name")
            }}</span>
            <span v-if="expenseType == 'Fitness'">{{
              $i18n.t("Certificate No")
            }}</span>
            <span v-if="expenseType == 'PUC'">{{ $i18n.t("PUC No.") }}</span>
            <span v-if="expenseType == 'Road Tax'">{{
              $i18n.t("Road Tax No.")
            }}</span>
            <span v-if="expenseType == 'Others'">{{
              $i18n.t("Other Info")
            }}</span>
            <span v-if="expenseType == 'Service'">{{
              $i18n.t("Service No.")
            }}</span>
          </th>
          <th class="primary--text">{{ $i18n.t("Purchase Date") }}</th>
          <th class="primary--text">{{ $i18n.t("Start") }}</th>
          <th class="primary--text">{{ $i18n.t("Expiry") }}</th>
          <th class="primary--text">{{ $i18n.t("Issuing Authority") }}</th>
          <th class="primary--text">{{ $i18n.t("Fare") }}</th>
          <th class="text-right primary--text"></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(expense, index) in grid.rows" :key="index">
          <td>{{ expense.title }}</td>
          <td>{{ formatDate(expense.date) }}</td>
          <td>{{ formatDate(expense.affectFrom) }}</td>
          <td>{{ formatDate(expense.expiry) }}</td>
          <td>
            {{
              expense.vendor_id != null && expense.vendor_id != "null"
                ? expense.vendorName
                : expense.organization.name
            }}
          </td>
          <td>{{ expense.fare.currency }} {{ expense.fare.total }}</td>
          <td>
            <z-confirm-button
              class="float-right"
              color="red lighten-1"
              x-small
              fab
              text
              :loading="expense.e_loading"
              :message="$i18n.t('Do you want to delete this Expense ?')"
              @click="deleteExpense(expense)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </z-confirm-button>

            <z-expense-create
              color="blue"
              style="float: right"
              x-small
              :expenseEdit_id="expense._id"
              @reload="fetchExpensesGrid()"
              btn
            >
              <v-btn color="cyan" text fab x-small>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </z-expense-create>

            <!-- <v-btn
              class="float-right"
              text
              fab
              x-small
              color="blue"
              :href="'/expense/' + expense._id"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn> -->
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Expenses",
  props: {
    value: {
      default: null,
    },
    expenseType: {
      default: null,
    },
    entity_id: {
      default: null,
    },
    // reloadExpenses: {
    //   default: false,
    // },
  },
})
export default class Expenses extends Vue {
  grid = null;
  loading = null;
  expenses_loading = null;

  prepareExpenses(grid) {
    if (grid && grid.rows) {
      for (let i = 0; i < grid.rows.length; i++) {
        grid.rows[i].e_loading = null;
      }
    }
  }

  async fetchExpensesGrid() {
    let url =
      "/api/expense/grid?_search=true&accountCode=VehicleExpense&rows=30&vehicle_id=" +
      this.entity_id;

    if (this.expenseType == "Insurance") {
      url = url + "&expenseType=Insurance";
    } else if (this.expenseType == "Service") {
      url = url + "&expenseTypes=Maintenance,Repair";
    } else if (this.expenseType == "Permits") {
      url = url + "&expenseType=Permits";
    } else if (this.expenseType == "Fitness") {
      url = url + "&expenseType=Fitness";
    } else if (this.expenseType == "PUC") {
      url = url + "&expenseType=PUC";
    } else if (this.expenseType == "Road Tax") {
      url = url + "&expenseType=Road Tax";
    } else if (this.expenseType == "Others") {
      url = url + "&expenseType=Others";
    }

    this.expenses_loading = true;
    const grid = await doGet(url);
    this.expenses_loading = null;
    this.prepareExpenses(grid);
    this.grid = grid;
  }

  async mounted() {
    this.fetchExpensesGrid();
    this.$parent.$on("reloadExpenses", (data) => {
      this.fetchExpensesGrid();
    });
  }

  reloadExpenses1() {
    // this.fetchExpensesGrid();
  }

  async deleteExpense(expense) {
    common.setLoading(true);
    try {
      expense.e_loading = true;
      await doGet("/api/expense/" + expense._id + "/delete");
      expense.e_loading = null;
      this.fetchExpensesGrid();
      common.showMessage("Deleted Successfully");
    } catch (e) {
      expense.e_loading = null;
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>
